import produce from "immer";

import { ClientPublicCandidateState } from "../clientPublicCandidateState";
import {
    CombinedClientPublicCandidateActionTypes,
} from "../combinedClientPublicCandidateActions";
import names from "./clientPublicCandidateActionTypes";

export const publicCandidateReducer = (
    state: ClientPublicCandidateState,
    action: CombinedClientPublicCandidateActionTypes
) =>
    produce(state, draft => {
        switch (action.type) {
            case names.LOAD_CANDIDATE: {
                draft.ui.isCandidateLoading = true;
                break;
            }

            case names.LOAD_CANDIDATE_SUCCESS: {
                draft.data.candidate = action.payload.candidate;
                draft.ui.isCandidateLoading = false;
                draft.ui.error = undefined;

                break;
            }

            case names.LOAD_CANDIDATE_FAILURE: {
                draft.ui.isCandidateLoading = false;
                draft.ui.error = {
                    type: "loading",
                    apiError: action.payload.apiError,
                };
                break;
            }
        }
    });
